import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { IndeedFlexProvider } from '../context/IndeedFlexProvider'
import { IndeedFlexShiftActionsProvider } from '../shared/context/IndeedFlexShiftActionsProvider'
import { IndeedFlexShiftIssuesProvider } from './context/IndeedFlexShiftIssuesProvider'
import { IndeedFlexShiftIssuesMain } from './components/IndeedFlexShiftIssuesMain'

export const IndeedFlexShiftIssues = () => {
  return (
    <NuqsAdapter>
      <IndeedFlexProvider>
        <IndeedFlexShiftActionsProvider>
          <IndeedFlexShiftIssuesProvider>
            <IndeedFlexShiftIssuesMain />
          </IndeedFlexShiftIssuesProvider>
        </IndeedFlexShiftActionsProvider>
      </IndeedFlexProvider>
    </NuqsAdapter>
  )
}
